import { createSlice } from "@reduxjs/toolkit";
import { translateChatMessage } from '../utils/awsAPI';
const _ = require('lodash');

const initialState = {
    chats: [{}],
    numberOfChats: 0,
    newIncomingChat: false,
    newIncomingEmail: false,
    newIncomingChatMissedTimer: "0",
    isItMissed: false,
    isEmailMissed:false,
    isEmailRejected:false,
    isItRejected: false,
    isItEmail:false,
    isTranslationDisabledByAgent:false,
    selectedChat: "",
    selectedName: "",
    selectedConversation: [],
    isSelectedChatEnded: false,
    selectedType: "",
    selectedInfo: [],
    lastAction: 0,
};

export async function sendMessage(chats: any, chatToSendMessage: string, message: string, language: string, agentLanguage: string, contactId: string, account: string, translationEnabled: boolean, translationDisabledByAgent: boolean,Speaker:string) {
    let msg = message;
    for(let i = 0; i < chats.length; i++){
        if(chats[i]["id"] === chatToSendMessage){
            if(!(language === agentLanguage || language === "Unknown" || agentLanguage === "Unknown") && translationEnabled && !translationDisabledByAgent){
                let translation = await translateChatMessage(msg, agentLanguage, language, contactId, Speaker,account);
                msg = translation.translatedMessage;
            }
            chats[i]["session"].sendMessage({
                message: msg,
                contentType: "text/plain"
            });
        }
    }
};

export async function addInCall(chats: any, endpointId: any, quickContactList: any, connection: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        let selectedEndPoint = endpointId;
        const endPoint = quickContactList.find((list: any) => { return list.endpointId === selectedEndPoint })
        for (let i = 0; i < chats.length; i++) {
            if (chats[i]["id"] === connection) {
                chats[i]["contactObject"].addConnection(endPoint, {
                    success: function () {
                        console.log("ConnectionComponent::AddInCall::Add In Call Success ");
                        resolve(true); 
                    },
                    failure: function (err: any) {
                        console.log("ConnectionComponent::AddInCall::Add In Call Failed");
                        console.log(err);
                        reject(err); 
                    }
                })
            }
        }
    });
}



export async function sendAttachment(chats: any, chatToSendMessage: any, file: any) {
    let success = true;
    for(let i = 0; i < chats.length; i++) {
        if(chats[i]["session"].controller.contactId === chatToSendMessage) {
            await chats[i]["session"].controller.sendAttachment({
                attachment: file
            }).catch((err: any) => {console.log("SendAttachment failed. Files cannot exceed 20 MB"); console.log(err); success = false;});
        }
    }

    return success;
}

function getTime(dateTime: string){
    let splitIndex = dateTime.indexOf(":") - 2;
    let time = dateTime.substring(splitIndex, splitIndex + 8);
    return time;
}

function getDateTime(dateTime: string){
    let splitIndex = dateTime.indexOf(":") + 6;
    let time = dateTime.substring(0, splitIndex);
    return time;
}

const chatSlice = createSlice({
    name: 'chatSlice',
    initialState: initialState,
    reducers: {
        createNewChat(state, action) {
            let newChat = true;
            if(newChat) {
                if(Object.keys(state.chats[0]).length === 0) {
                    state.chats = [{"id": action.payload.participantId, "customerLanguage": action.payload.customerLanguage, "agentLanguage": action.payload.agentLanguage, "account": action.payload.account, "absoluteTime": action.payload.absoluteTime, "isEnded": false, "name": action.payload.displayName, "contactInfo": action.payload.contactInfo, "type": action.payload.type, "conversation": [], "session": action.payload.session, "contactObject": action.payload.contact, "hasNotification": false}];
                } else {
                    state.chats.push({"id": action.payload.participantId, "customerLanguage": action.payload.customerLanguage, "agentLanguage": action.payload.agentLanguage, "account": action.payload.account, "absoluteTime": action.payload.absoluteTime, "isEnded": false, "name": action.payload.displayName, "contactInfo": action.payload.contactInfo, "type": action.payload.type, "conversation": [], "session": action.payload.session, "contactObject": action.payload.contact, "hasNotification": false});
                }
                state.numberOfChats++;
            }
        },

        changeNewIncomingChat(state, action) {
            state.newIncomingChat = action.payload.newIncomingChat;
        },
        changeNewIncomingEmail(state, action) {
            state.newIncomingEmail = action.payload.newIncomingEmail;
        },

        changeIsItMissed(state, action) {
            state.isItMissed = action.payload.isItMissed;
        },
        
        changeisEmailMissed(state, action) {
            state.isEmailMissed = action.payload.isEmailMissed;
        },
        changeisEmailRejected(state, action) {
            state.isEmailRejected = action.payload.isEmailRejected;
        }, 
        changeisItEmail(state, action) {
            state.isItEmail = action.payload.isItEmail;
        },

        changeIsItRejected(state, action) {
            state.isItRejected = action.payload.isItRejected;
        },

        changeIsTranslationDisabledByAgent(state, action) {
            state.isTranslationDisabledByAgent = action.payload.isTranslationDisabledByAgent;
        },

        changeNewIncomingChatMissedTimer(state, action) {
            state.newIncomingChatMissedTimer = action.payload.newIncomingChatMissedTimer;
        },

        changeSelectedChat(state: any, action) {
            state.selectedChat = action.payload.newSelectedChat;
            for(let i = 0; i < state.chats.length; i++) {
                if(state.chats[i]["id"] === action.payload.newSelectedChat) {
                    state.selectedName = state.chats[i]["name"];
                    state.selectedConversation = state.chats[i]["conversation"];
                    state.isSelectedChatEnded = state.chats[i]["isEnded"];
                    state.selectedType = state.chats[i]["type"];
                    state.selectedInfo = state.chats[i]["contactInfo"];
                }
            }
        },

        changeAbsoluteTime(state: any, action) {
            for(let i = 0; i < state.chats.length; i++) {
                if(state.chats[i]["id"] === action.payload.chatId) {
                    state.chats[i]["absoluteTime"] = action.payload.absoluteTime;
                }
            }
        },

        addNewMessage(state: any, action) {
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId) {
                    state.chats[i]["conversation"].push({"type": "text/plain", "message": action.payload.content, "isYours": action.payload.participantRole === "AGENT", "isSystemMessage": action.payload.participantRole === "SYSTEM", "needTranslation": action.payload.needTranslation, "epochTime": action.payload.epochTime, "time": getTime(action.payload.dateTime), "dateTime": getDateTime(action.payload.dateTime)});
                    if(state.selectedChat === action.payload.participantId) {
                        state.selectedConversation = state.chats[i]["conversation"];
                    }
                    if(action.payload.participantRole !== "AGENT" && action.payload.participantId !== state.selectedChat){
                        state.chats[i]["hasNotification"] = true;
                    }
                }
            }
        },

        addNewAttachment(state: any, action) {
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId){
                    state.chats[i]["conversation"].push({"type": "attachment", "success": true, "message": action.payload.content, "isYours": action.payload.participantRole === "AGENT", "url": action.payload.url, "isSystemMessage": action.payload.participantRole === "SYSTEM", "time": getTime(action.payload.dateTime), "dateTime": getDateTime(action.payload.dateTime)});
                    if(state.selectedChat === action.payload.participantId){
                        state.selectedConversation = state.chats[i]["conversation"];
                    }
                    if(action.payload.participantRole !== "AGENT" && action.payload.participantId !== state.selectedChat){
                        state.chats[i]["hasNotification"] = true;
                    }
                }
            }
        },

        changeAttachment(state: any, action) {
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId){
                    state.chats[i]["conversation"].forEach((message: any) => {
                        if(message["type"] === "attachment" && message["url"] === action.payload.url) {
                            message["success"] = false;
                            //message["message"] = "There was an error with the attachment " + message["message"] + ". Download the logs for more information.";
                        }
                    });
                    if(state.selectedChat === action.payload.participantId){
                        state.selectedConversation = state.chats[i]["conversation"];
                    }
                }
            }
        },

        updateLastAction(state) {
            var dt = new Date();
            state.lastAction = dt.getTime();
        },

        endChat(state: any, action) {
            for(let i = 0; i < state.chats.length; i++) {
                if(state.chats[i]["id"] === action.payload.chatId) {
                    state.chats[i]["isEnded"] = true;
                    state.chats[i]["absoluteTime"] = Math.round(Date.now() / 1000);
                    if(state.selectedChat === state.chats[i]["id"]) {
                        state.isSelectedChatEnded = true;
                    }
                    state.chats[i]["session"].controller.disconnectParticipant();
                }
            }
            state.numberOfChats--;
        },

        changeMessage(state: any, action){
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId){
                    for(let j = 0; j < state.chats[i]["conversation"].length; j++){
                        if(state.chats[i]["conversation"][j]["type"] === "text/plain" && state.chats[i]["conversation"][j]["epochTime"] === action.payload.epochTime && state.chats[i]["conversation"][j]["message"] === action.payload.originalMsg){
                            state.chats[i]["conversation"][j]["message"] = action.payload.translatedMsg;
                            state.chats[i]["conversation"][j]["needTranslation"] = false;
                            if(state.selectedChat === action.payload.participantId){
                                state.selectedConversation = state.chats[i]["conversation"];
                            }
                            break;
                        }
                    }
                    break;
                }
            }
        },

        closeContact(state: any, action){
            var newChats = _.cloneDeep(state.chats);
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.chatId){
                    state.chats[i]["contactObject"].clear();
                    newChats.splice(i, 1);
                }
            }
            if(newChats.length === 0){
                newChats = [{}];
            }
            state.chats = newChats;
            if(state.selectedChat === action.payload.chatId){
                state.selectedChat = "";
                state.selectedName = "";
                state.selectedConversation = [];
                state.isSelectedChatEnded = false;
                state.selectedType = "";
                state.selectedInfo = [];
            }
        },

        removeNotification(state: any, action){
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId){
                    state.chats[i]["hasNotification"] = false;
                }
            }
        },

        addNotification(state: any, action){
            for(let i = 0; i < state.chats.length; i++){
                if(state.chats[i]["id"] === action.payload.participantId){
                    state.chats[i]["hasNotification"] = true;
                }
            }
        },
    }
});

export const chatSliceAction = chatSlice.actions;
export default chatSlice.reducer;